import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Artist from '../views/artist.vue'
import Engineer from '../views/engineer.vue'
import Press from '../views/press.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/artist',
    name: 'Artist',
    component: Artist
  },
  {
    path: '/engineer',
    name: 'Engineer',
    component: Engineer
  },
  {
    path: '/press',
    name: 'Press',
    component: Press
  },
]

const router = new VueRouter({
  routes
})

export default router
